import { Link } from "fusion-plugin-react-router";
import Lottie from "lottie-react";
import animationData from "../../../../../assets/animations/tbSuccessfulPaymentAnimation.json";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import {
  clearAllStores,
  clearSupportStore,
} from "../../../../../shared/utils/storeUtils";

const SpComplete = () => {
  return (
    <QuoteFormWrapper>
      <div
        style={{ width: "44px", height: "44px" }}
        className="margin-bottom-20"
      >
        <Lottie
          animationData={animationData}
          loop={false}
          autoplay={true}
          rendererSettings={{
            preserveAspectRatio: "xMidYMid slice",
          }}
          style={{
            width: "100%",
            height: "100%",
            marginLeft: "-7px",
            marginTop: "-7px",
          }}
        />
      </div>
      <h1 className="margin-bottom-30">Complete</h1>
      <p className="gray-text">
        Thank you for providing the details. Your change will now be referred to
        our Underwriting department and you will receive a quote via email and
        SMS. Your quote will contain a payment link which will allow you to pay
        and accept the changes. Once we receive payment, we will then process
        the change for you and issue new documents to your email.
      </p>

      <Link
        to="/landing"
        className="getStartedButton"
        onClick={() => {
          clearSupportStore();
          clearAllStores();
        }}
      >
        Back to Portal
      </Link>
    </QuoteFormWrapper>
  );
};

export default SpComplete;
